__turbopack_context__.v({
  "nodejsLogo": "index-module__YC5Knq__nodejsLogo",
});
